var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "md-dialog",
        {
          staticClass: "e-mentoring-dialog standard-dialog-style",
          attrs: { "md-active": _vm.showEmailError },
          on: {
            "update:mdActive": function ($event) {
              _vm.showEmailError = $event
            },
            "update:md-active": function ($event) {
              _vm.showEmailError = $event
            },
          },
        },
        [
          _c("md-dialog-title", [
            _vm._v(_vm._s(_vm.t("app-mentor-city-account-already-exists"))),
          ]),
          _vm._v(" "),
          _c("md-dialog-content", {
            domProps: {
              innerHTML: _vm._s(
                _vm.t("app-mentor-city-account-already-exists-body")
              ),
            },
          }),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  attrs: { type: "submit" },
                  on: {
                    click: function ($event) {
                      _vm.showEmailError = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t("app-okay")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "md-dialog",
        {
          staticClass: "e-mentoring-dialog standard-dialog-style",
          attrs: { "md-active": _vm.show },
          on: {
            "update:mdActive": function ($event) {
              _vm.show = $event
            },
            "update:md-active": function ($event) {
              _vm.show = $event
            },
          },
        },
        [
          _c("md-dialog-title", [
            _vm._v(_vm._s(_vm.t("app-request-access-to-e-mentoring-platform"))),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "standard-form-style",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.request.apply(null, arguments)
                },
              },
            },
            [
              _c("md-dialog-content", [
                _c(
                  "div",
                  { staticClass: "ui-form-row" },
                  [
                    _c("app-input", {
                      attrs: {
                        type: "text",
                        label: _vm.t("app-program-title"),
                        required: "true",
                      },
                      model: {
                        value: _vm.title,
                        callback: function ($$v) {
                          _vm.title = $$v
                        },
                        expression: "title",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ui-form-row" }, [
                  _c("div", { staticClass: "description" }, [
                    _vm._v(
                      _vm._s(
                        _vm.t(
                          "app-request-access-to-e-mentoring-platform-program-body"
                        )
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ui-form-row col-2" },
                  [
                    _c("app-input", {
                      attrs: {
                        type: "text",
                        label: _vm.t("app-first-name"),
                        required: "true",
                        pattern: ".{2,}",
                        oninvalid:
                          "this.setCustomValidity(window.app.t('app-two-character-minimum'))",
                      },
                      model: {
                        value: _vm.firstName,
                        callback: function ($$v) {
                          _vm.firstName = $$v
                        },
                        expression: "firstName",
                      },
                    }),
                    _vm._v(" "),
                    _c("app-input", {
                      attrs: {
                        type: "text",
                        label: _vm.t("app-last-name"),
                        required: "true",
                        pattern: ".{2,}",
                        oninvalid:
                          "this.setCustomValidity(window.app.t('app-two-character-minimum'))",
                      },
                      model: {
                        value: _vm.lastName,
                        callback: function ($$v) {
                          _vm.lastName = $$v
                        },
                        expression: "lastName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "ui-form-row col-2" },
                  [
                    _c("app-input", {
                      attrs: {
                        type: "text",
                        label: _vm.t("app-contact-phone"),
                        required: "true",
                      },
                      model: {
                        value: _vm.phone,
                        callback: function ($$v) {
                          _vm.phone = $$v
                        },
                        expression: "phone",
                      },
                    }),
                    _vm._v(" "),
                    _c("app-input", {
                      attrs: {
                        type: "text",
                        label: _vm.t("app-email"),
                        required: "true",
                      },
                      model: {
                        value: _vm.email,
                        callback: function ($$v) {
                          _vm.email = $$v
                        },
                        expression: "email",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ui-form-row" }, [
                  _c("fieldset", [
                    _c("div", { staticClass: "description" }, [
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.t("app-e-mentoring-logo-content")
                          ),
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("p", {
                      staticClass: "description tip",
                      domProps: {
                        innerHTML: _vm._s(_vm.t("app-e-mentoring-logo-tip")),
                      },
                    }),
                    _vm._v(" "),
                    _vm.logoError
                      ? _c("div", { staticClass: "description error" }, [
                          _c("p", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.t("app-mentorcity-logo-error")
                              ),
                            },
                          }),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ui-form-row" },
                      [
                        _c("logo-uploader", {
                          ref: "mentor-city-logo-uploader",
                          attrs: { id: "mentorcity-logo-file" },
                          model: {
                            value: _vm.program.mentorCityLogo,
                            callback: function ($$v) {
                              _vm.$set(_vm.program, "mentorCityLogo", $$v)
                            },
                            expression: "program.mentorCityLogo",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "ui-form-row",
                    attrs: { id: "terms-of-service-div" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "ui-checkbox-field ui-field ui-option-field",
                      },
                      [
                        _c("div", { staticClass: "ui-option-field-wrapper" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.termsOfService,
                                expression: "termsOfService",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "terms-of-service",
                              required: "required",
                            },
                            domProps: {
                              checked: Array.isArray(_vm.termsOfService)
                                ? _vm._i(_vm.termsOfService, null) > -1
                                : _vm.termsOfService,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.termsOfService,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.termsOfService = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.termsOfService = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.termsOfService = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "ui-checkbox-state-indicator ui-option-state-indicator",
                            },
                            [
                              _c("svg", { attrs: { viewBox: "0 0 14 14" } }, [
                                _c("path", {
                                  staticClass: "ui-checkbox-checkmark-path",
                                  attrs: {
                                    fill: "none",
                                    d: "M1.01,7.53l3.72,3.72l8.57-8.5",
                                  },
                                }),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", {
                            staticClass:
                              "ui-checkbox-secondary-indicator ui-option-secondary-indicator",
                          }),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "ui-option-label" }, [
                          _c("label", { attrs: { for: "terms-of-service" } }, [
                            _vm._v(
                              "\n                " +
                                _vm._s(
                                  _vm.t("app-i-have-read-and-agree-to-the")
                                ) +
                                "\n                "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.t("app-footer-terms-of-use-link"),
                                  target: "_blank",
                                },
                              },
                              [_vm._v(_vm._s(_vm.t("app-footer-terms-of-use")))]
                            ),
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.t("and")) +
                                "\n                "
                            ),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.t("app-footer-privacy-policy-link"),
                                  target: "_blank",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.t("app-footer-privacy-policy"))
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "md-dialog-actions",
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary",
                      on: {
                        click: function ($event) {
                          _vm.show = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.t("app-cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "md-button",
                    { staticClass: "md-primary", attrs: { type: "submit" } },
                    [_vm._v(_vm._s(_vm.t("app-request-access")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.inviteSent
        ? _c("div", { staticClass: "ui-form-row edit-organization-buttons" }, [
            _c(
              "button",
              {
                staticClass: "compact",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    _vm.show = true
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.t("app-request-access-to-e-mentoring-platform")
                    ) +
                    "\n    "
                ),
              ]
            ),
          ])
        : _c("div", {
            staticClass: "ui-form-row typography-reduced e-mentoring-details",
            domProps: { innerHTML: _vm._s(_vm.eMentoringInviteMessage) },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }